import $ from 'jquery';
import { Autoplay, EffectFade, Navigation, Pagination, Swiper } from 'swiper';

import { $Elements, Classes, Durations, Events } from './constants';
import { disableBodyScroll, enableBodyScroll, smoothScrollTo, wait } from './helpers';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Carousel ----------

	$('.content-section:not(.other-posts-section) .section-carousel, .content-section:not(.other-posts-section) .column-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.default.ms,
				loop: true,
				observer: true,
				modules: [Navigation, Pagination],
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

	// ---------- Slideshow ----------

	$('.content-section .section-slideshow, .content-section .column-slideshow').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.default.ms,
				loop: true,
				observer: true,
				autoplay: true,
				effect: 'fade',
				modules: [Autoplay, EffectFade, Navigation, Pagination],
				fadeEffect: {
					crossFade: true,
				},
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

	// ---------- Home Introduction ----------

	$('.home-introduction-section').each(async function() {

		const section = $(this);

		section.on('click', '.home-introduction-btn', function() {

			const index = parseInt(this.dataset.index);
			const slides = $('.home-introduction-slide');

			if(slides.length && slides[index]) {

				const offset = (!index) ? 0 : (index === slides.length - 1) ? -window.innerHeight / 2 : -window.innerHeight;
				smoothScrollTo(slides[index], Durations.page.s, offset);
			}
			else {

				const next = (section.next().length) ? section.next() : $Elements.FooterWrapper;
				smoothScrollTo(next[0], Durations.page.s);
			}
		});

		$Elements.body.addClass(Classes.introducing);
		disableBodyScroll();

		await wait(Durations.page.ms);

		section.removeClass(Classes.introducing);

		await wait(Durations.page.ms + Durations.animations.ms);

		$Elements.body.removeClass(Classes.introducing);
		enableBodyScroll();

	});

	// ---------- Other Post section  ----------
	$('.other-posts-section .section-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.default.ms,
				loop: true,
				slidesPerView: 'auto',
				observer: true,
				modules: [ Pagination],
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				centeredSlides:true,
				breakpoints:{
					1024:{
						loop:false,
						centeredSlides:false,
					}
				}
			});
		}
	});
});
